import {useIntl} from "react-intl";
import {useCallback, useContext} from "react";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "./useCountryAxiosInstance";
import {NotificationsContext} from "../ui-components/Notifications";

const useDispatchServiceAp = (serviceId) => {
  const intl = useIntl();
  const {push} = useContext(NotificationsContext);
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  return useCallback(
    async (prev, curr) => {
      if (!prev && !curr) {
        // case A: no ap were provided --> create a new one and return
        return await countryApiRequest.post('/services_price_analysis', {
          id_service: serviceId,
          id_price_analysis_item: null,
          des_title: intl.formatMessage({id: 'new_ap_title'}),
          des_description: intl.formatMessage({id: 'new_ap_description'}),
          flg_active: false,
          dependencies: [],
          calculation: [],
          r_perm: ['public'],
          w_perm: ['admin'],
        })
      }

      const {id, items, ...reducedAP} = curr;
      const extItems = items.map((i) => {
        const {price_analysis_item, info, ...rest} = i;
        return {...rest, id_service_price_analysis: id};
      })

      let refreshed, toUpsert, toDelete;
      if (!prev) {
        // case B: only current ap was provided --> duplication
        refreshed = await countryApiRequest.post(`/services_price_analysis`, reducedAP);
        toUpsert = extItems.map((i) => {
          const {id, ...rest} = i;
          return {...rest, id_service_price_analysis: refreshed.id}
        });
        toDelete = []
      }
      else {
        // case C: ap was provided --> update existing ap and items
        toUpsert = extItems;
        toDelete = prev.items
          .filter((pi) => !items.some((ci) => ci.id === pi.id))
          .map((pi) => pi.id);

        // TEMPORARY: some users have reported cases in which all items were deleted (but the price analysis was still
        // present). As for now, case C seems to be the only way this can occur, but we couldn't figure out why. In
        // order to avoid this behavior, we are going to prevent it manually - if the users wants to delete all
        // item, they must delete the whole price analysis instead
        if (toDelete.length > 0 && toDelete.length === prev.items.length) {
          const confirmed = window.confirm(intl.formatMessage({id: 'prevent_ap_items_removal_warning'}))
          if (!confirmed) {
            return null
          }
        }
        refreshed = await countryApiRequest.put(`/services_price_analysis/${id}`, reducedAP)
      }
      refreshed['items'] = await countryApiRequest.post(
        `/services_price_analysis_items/update`,
        {items: toUpsert, to_delete: toDelete}
      );

      return refreshed;
    },
    [serviceId, countryApiRequest, intl],
  );
}

export default useDispatchServiceAp;